var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!(_vm.source.length < _vm.maxRes)) ? _c('p', {
    staticStyle: {
      "margin-left": "15px",
      "margin-top": "40px"
    }
  }, [_vm._v(" " + _vm._s(_vm.$Jed.firstUpperTranslate("This research is too generic, these are the first") + " " + _vm.maxRes + " " + _vm.$Jed.translate("results found")))]) : _vm._e(), _vm._v(" "), (_vm.modelNotFound) ? _c('p', {
    staticStyle: {
      "margin-left": "15px",
      "margin-top": "40px"
    }
  }, [_vm._v(" " + _vm._s(_vm.$Jed.firstUpperTranslate("Results not filtered because model not found")))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default",
    staticStyle: {
      "margin": "0px 10px"
    }
  }, [_c('div', {
    staticClass: "panel-heading headers",
    staticStyle: {
      "padding": "10px 0px",
      "display": "table",
      "width": "100%"
    },
    attrs: {
      "role": "tab"
    }
  }, _vm._l((_vm.results_cols), function(r_col) {
    return _c('span', {
      staticStyle: {
        "display": "table-cell",
        "vertical-align": "middle",
        "padding": "0px 5px"
      },
      style: ({
        'width': r_col.width[_vm.type]
      })
    }, [_c('span', [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate(r_col.text)))])])
  }))]), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "panel-group resultsTable",
    staticStyle: {
      "margin-bottom": "0px"
    },
    attrs: {
      "id": _vm.id,
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [_vm._l((_vm.source), function(res, index) {
    return _c('div', {
      staticClass: "panel panel-default",
      staticStyle: {
        "margin": "0px 0px 1px 0px"
      }
    }, [_c('div', {
      staticClass: "panel-heading",
      class: {
        'collapsed': _vm.activeSearch != index
      },
      staticStyle: {
        "padding": "10px 0px"
      },
      attrs: {
        "role": "tab",
        "data-toggle": "collapse",
        "href": '#collapse' + index,
        "aria-expanded": "true",
        "aria-controls": 'collapse' + index
      }
    }, _vm._l((_vm.results_cols), function(r_col) {
      return _c('span', {
        style: ({
          'width': r_col.width[_vm.type],
          'display': 'inline-block',
          'padding': '0px 5px',
          'vertical-align': 'middle'
        })
      }, [(r_col.datafield == 'typ') ? _c('span', [_c('i', {
        class: _vm.getIconClass(res)
      })]) : (r_col.datafield == 'gra') ? _c('span', {
        class: {
          'pointer': r_col.ex != null
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            r_col.ex ? r_col.ex(res) : null
          }
        }
      }, [(res.doc && res.doc.length > 0) ? _c('div', {
        staticClass: "embed-responsive embed-responsive-4by3 bg-cover",
        style: ({
          'width': '100%',
          'background-image': 'url(' + _vm.anteprima(res.doc, 'doc') + ')'
        })
      }) : _c('div', {
        staticClass: "embed-responsive embed-responsive-4by3 bg-cover",
        style: ({
          'width': '100%',
          'background-image': 'url(' + _vm.anteprima(res.gra, 'gra') + ')'
        })
      })]) : _c('span', {
        class: {
          'pointer': r_col.ex != null
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            r_col.ex ? r_col.ex(res) : null
          }
        }
      }, [_vm._v(_vm._s(res[r_col.datafield]))])])
    })), _vm._v(" "), (_vm.type == 'criteria' && !_vm.$root.preferences.splitSearch) ? _c('div', {
      staticClass: "panel-collapse collapse",
      attrs: {
        "id": 'collapse' + index,
        "role": "tabpanel"
      }
    }, [(_vm.$root.preferences.splitSearch && res.fat == null) ? _c('div', {
      staticStyle: {
        "padding-bottom": "10px"
      }
    }, [_vm._m(0, true)]) : (_vm.$Behaviors.search.fathersDescriptions) ? _vm._l((res.fat), function(fath) {
      return _c('div', {
        class: {
          'active': (fath.id == _vm.$root.active_tree_item.id && (_vm.$route.query.p == fath.a_idp || _vm.$route.query.p == null))
        },
        staticStyle: {
          "display": "table",
          "width": "100%"
        }
      }, _vm._l((_vm.$Behaviors.search.fathersDescriptions), function(fd_col, i) {
        return _c('span', {
          staticClass: "customCell",
          class: {
            'pointer': i == fath.idpdes.length - 1 ? true : null
          },
          style: ({
            'width': fd_col.width,
            'text-decoration': i == fath.idpdes.length - 1 ? 'underline' : '',
            'text-decoration-color': i == fath.idpdes.length - 1 ? '#3c8dbc' : '',
            'color': i == fath.idpdes.length - 1 ? '#3c8dbc' : ''
          }),
          on: {
            "click": function($event) {
              $event.preventDefault();
              res.typ == 'Modello' ? _vm.navigateToNode(res) : i == fath.idpdes.length - 1 ? _vm.navigateToFather(fath) : null
            }
          }
        }, [_c('div', [_vm._v(_vm._s(fath.idpdes[i]))])])
      }))
    }) : _vm._l((res.fat), function(fath) {
      return _c('div', {
        class: {
          'active': (fath.id == _vm.$root.active_tree_item.id && (_vm.$route.query.p == fath.a_idp || _vm.$route.query.p == null))
        },
        staticStyle: {
          "display": "table",
          "width": "100%"
        }
      }, _vm._l((_vm.fathers_cols), function(f_col) {
        return _c('span', {
          staticClass: "customCell",
          class: {
            'pointer': f_col.ex != null
          },
          style: ({
            'width': f_col.width
          }),
          on: {
            "click": function($event) {
              $event.preventDefault();
              f_col.ex ? f_col.ex(fath) : null
            }
          }
        }, [(f_col.datafield == 'typ') ? _c('span', [_c('i', {
          class: _vm.getIconClass(fath)
        })]) : (f_col.datafield == 'des') ? _c('span', [_c('div', [_vm._v(_vm._s(fath.des))]), _vm._v(" "), (fath.idp) ? _c('div', {
          staticStyle: {
            "font-size": "smaller"
          }
        }, [_c('i', {
          class: _vm.$root.icons.tree_son
        }), _vm._v(" "), _c('span', {
          staticStyle: {
            "font-weight": "600"
          }
        }, [_vm._v(_vm._s(fath.idp[0]))]), _vm._v(" "), (fath.idp.length > 1) ? _c('span', [_vm._v(_vm._s(' / ' + fath.idp.slice(1, fath.idp.length).join(' / ')))]) : _vm._e()]) : _vm._e()]) : _c('span', [_vm._v(_vm._s(fath[f_col.datafield]))])])
      }))
    })], 2) : _vm._e()])
  }), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "sk-cube-grid",
    staticStyle: {
      "position": "absolute",
      "top": "150px",
      "left": "300px"
    }
  }, [_c('div', {
    staticClass: "sk-cube sk-cube1 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube2 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube3 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube4 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube5 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube6 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube7 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube8 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube9 loading-nav-waiter"
  })]) : _vm._e()], 2) : _vm._e()])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-cube-grid",
    staticStyle: {
      "margin": "30px auto"
    }
  }, [_c('div', {
    staticClass: "sk-cube sk-cube1 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube2 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube3 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube4 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube5 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube6 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube7 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube8 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube9 loading-nav-waiter"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92512078","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu-components/SearchResults.vue
// module id = 1425
// module chunks = 1